import diContainer from "true-di";
import DiPageHoC from "./DiPageHoC/DiPageHoC";

const createContainer = (pageServices, coreServices) => context =>
	diContainer({
		globalContext: () => context,
		...coreServices,
		...pageServices,
	});

const NextPageWithServices = coreServices => Page =>
	DiPageHoC(createContainer(Page.services, coreServices))(Page);

export default NextPageWithServices;
